//via http://jsfiddle.net/themightymo/dfbmm0rs/8/
var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ? true : false;
$(document).ready(function() {
  if(!isMobile) {
	var prevSlide = null;
	var slider = $('#lightSlider').lightSlider({
	    adaptiveHeight:1,
	    item: 1,
	    slideMargin: 15,
        gallery: true,
     	controls: false,
      	enableDrag:false,
      	thumbItem:5,
        vThumbWidth:50,
        thumbMargin:4,
        adaptiveHeight: true,
      	onSliderLoad: function (el) {
          	el.find('li#slide-mar').zoom();
        },
	    onAfterSlide: function (el) {
	        prevSlide = slider.getCurrentSlideCount();
	    },
	    onBeforeSlide: function (el) {
	        if (prevSlide) {
	            var youtubePlayer = $('#lightSlider li').eq(prevSlide - 1).find('.ls-youtube').get(0),
	                vimeoPlayer = $('#lightSlider li').eq(prevSlide - 1).find('.ls-vimeo').get(0);
	            if (youtubePlayer) {
	                youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
	            } else if (vimeoPlayer) {
	                $f(vimeoPlayer).api("pause");
	            }
	        }
	
	    }
	})
  }else{
    var prevSlide = null;
	var slider = $('#lightSlider').lightSlider({
	    adaptiveHeight:1,
	    item: 1,
	    slideMargin: 15,
        gallery: true,
     	controls: false,
      	enableDrag:false,
      	thumbItem:5,
        vThumbWidth:50,
        thumbMargin:4,
        adaptiveHeight: true,
      	onSliderLoad: function(el) {
          	var $lg = el;
            $lg.lightGallery({
                selector: 'li#slide-mar, div#gal360'
            });
          	$lg.on('onAfterOpen.lg',function(event){
              	$( "div.lg-sub-html" ).click(function() {
                    Magic360.fullscreen('360spin');
                  	Magic360.spin('360spin');
                });
            });
        },
	    onAfterSlide: function (el) {
	        prevSlide = slider.getCurrentSlideCount();
	    },
	    onBeforeSlide: function (el) {
	        if (prevSlide) {
	            var youtubePlayer = $('#lightSlider li').eq(prevSlide - 1).find('.ls-youtube').get(0),
	                vimeoPlayer = $('#lightSlider li').eq(prevSlide - 1).find('.ls-vimeo').get(0);
	            if (youtubePlayer) {
	                youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
	            } else if (vimeoPlayer) {
	                $f(vimeoPlayer).api("pause");
	            }
	        }
	
	    }
	})
  };
});

$(document).ready(function() {
  if(!isMobile) {
	var prevSlide = null;
	var slider = $('#lightSliderC').lightSlider({
	    adaptiveHeight:1,
	    item: 1,
	    slideMargin: 15,
        gallery: true,
     	controls: false,
      	enableDrag:false,
      	loop:true,
      	thumbItem:5,
        vThumbWidth:50,
        thumbMargin:4,
      	autoWidth: false,
        adaptiveHeight: true,
      	onSliderLoad: function (el) {
          el.find('li#slide-mar').zoom();
        },
	    onAfterSlide: function (el) {
	        prevSlide = slider.getCurrentSlideCount();
	    },
	    onBeforeSlide: function (el) {
	        if (prevSlide) {
	            var youtubePlayer = $('#lightSliderC li').eq(prevSlide - 1).find('.ls-youtube').get(0),
	                vimeoPlayer = $('#lightSliderC li').eq(prevSlide - 1).find('.ls-vimeo').get(0);
	            if (youtubePlayer) {
	                youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
	            } else if (vimeoPlayer) {
	                $f(vimeoPlayer).api("pause");
	            }
	        }
	
	    }
	})
  }else{
    var prevSlide = null;
	var slider = $('#lightSliderC').lightSlider({
	    adaptiveHeight:1,
	    item: 1,
	    slideMargin: 15,
        gallery: true,
     	controls: false,
      	enableDrag:false,
      	loop:true,
      	thumbItem:5,
        vThumbWidth:50,
        thumbMargin:4,
      	autoWidth: false,
        adaptiveHeight: true,
      	onSliderLoad: function(el) {
            el.lightGallery({
                selector: 'li#slide-mar, div#gal360'
            });
        },
	    onAfterSlide: function (el) {
	        prevSlide = slider.getCurrentSlideCount();
	    },
	    onBeforeSlide: function (el) {
	        if (prevSlide) {
	            var youtubePlayer = $('#lightSliderC li').eq(prevSlide - 1).find('.ls-youtube').get(0),
	                vimeoPlayer = $('#lightSliderC li').eq(prevSlide - 1).find('.ls-vimeo').get(0);
	            if (youtubePlayer) {
	                youtubePlayer.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
	            } else if (vimeoPlayer) {
	                $f(vimeoPlayer).api("pause");
	            }
	        }
	
	    }
	})
  };
});